// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/poster.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Inter, system-ui, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-8 {
  left: 2rem;
  right: 2rem;
}
.-bottom-10 {
  bottom: -2.5rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-4 {
  left: 1rem;
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-ml-5 {
  margin-left: -1.25rem;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mt-\\[150px\\] {
  margin-top: -150px;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-16 {
  height: 4rem;
}
.h-6 {
  height: 1.5rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[54vh\\] {
  height: 54vh;
}
.h-\\[58vh\\] {
  height: 58vh;
}
.h-\\[unset\\] {
  height: unset;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[46vh\\] {
  max-height: 46vh;
}
.min-h-\\[56px\\] {
  min-height: 56px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1 {
  width: 0.25rem;
}
.w-10 {
  width: 2.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[3\\.2rem\\] {
  width: 3.2rem;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[44ch\\] {
  max-width: 44ch;
}
.max-w-full {
  max-width: 100%;
}
.max-w-prose {
  max-width: 65ch;
}
.flex-1 {
  flex: 1 1 0%;
}
.shrink-0 {
  flex-shrink: 0;
}
.origin-top {
  transform-origin: top;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.04\\] {
  --tw-scale-x: 1.04;
  --tw-scale-y: 1.04;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-grab {
  cursor: grab;
}
.cursor-grabbing {
  cursor: grabbing;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border-t {
  border-top-width: 1px;
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/55 {
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-festival-glow {
  --tw-bg-opacity: 1;
  background-color: rgb(246 192 84 / var(--tw-bg-opacity));
}
.bg-festival-glow\\/15 {
  background-color: rgb(246 192 84 / 0.15);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/25 {
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-\\[radial-gradient\\(120\\%_80\\%_at_50\\%_50\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\)_40\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.55\\)_100\\%\\)\\] {
  background-image: radial-gradient(120% 80% at 50% 50%,rgba(0,0,0,0) 40%,rgba(0,0,0,0.55) 100%);
}
.bg-\\[radial-gradient\\(120\\%_90\\%_at_50\\%_50\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\)_35\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.65\\)_100\\%\\)\\] {
  background-image: radial-gradient(120% 90% at 50% 50%,rgba(0,0,0,0) 35%,rgba(0,0,0,0.65) 100%);
}
.bg-\\[radial-gradient\\(120\\%_90\\%_at_50\\%_50\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\)_35\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.7\\)_100\\%\\)\\] {
  background-image: radial-gradient(120% 90% at 50% 50%,rgba(0,0,0,0) 35%,rgba(0,0,0,0.7) 100%);
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#FFD66E\\] {
  --tw-gradient-from: #FFD66E var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 214 110 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#FF9A3C\\] {
  --tw-gradient-to: #FF9A3C var(--tw-gradient-to-position);
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-5 {
  padding: 1.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-44 {
  padding-bottom: 11rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.font-display {
  font-family: Oswald, system-ui, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[15\\.5px\\] {
  font-size: 15.5px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.6\\] {
  line-height: 1.6;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.tracking-\\[0\\.28em\\] {
  letter-spacing: 0.28em;
}
.tracking-\\[0\\.35em\\] {
  letter-spacing: 0.35em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-festival-glow {
  --tw-text-opacity: 1;
  color: rgb(246 192 84 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85 {
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.underline {
  text-decoration-line: underline;
}
.decoration-festival-glow\\/60 {
  text-decoration-color: rgb(246 192 84 / 0.6);
}
.decoration-2 {
  text-decoration-thickness: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow-\\[0_18px_70px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.65\\)\\] {
  --tw-shadow: 0 18px 70px rgba(0,0,0,0.65);
  --tw-shadow-colored: 0 18px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_25px_120px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.75\\)\\] {
  --tw-shadow: 0 25px 120px rgba(0,0,0,0.75);
  --tw-shadow-colored: 0 25px 120px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-festival-glow\\/40 {
  --tw-ring-color: rgb(246 192 84 / 0.4);
}
.ring-white\\/10 {
  --tw-ring-color: rgb(255 255 255 / 0.1);
}
.ring-white\\/20 {
  --tw-ring-color: rgb(255 255 255 / 0.2);
}
.ring-white\\/25 {
  --tw-ring-color: rgb(255 255 255 / 0.25);
}
.ring-white\\/30 {
  --tw-ring-color: rgb(255 255 255 / 0.3);
}
.ring-white\\/70 {
  --tw-ring-color: rgb(255 255 255 / 0.7);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[clip-path\\2c opacity\\] {
  transition-property: clip-path,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[grid-template-rows\\] {
  transition-property: grid-template-rows;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-transform {
  will-change: transform;
}
.text-glow {
    text-shadow: 0 2px 22px rgba(246, 192, 84, 0.35);
  }
.btn-primary {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(246 192 84 / var(--tw-bg-opacity));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.btn-primary:hover {
  --tw-shadow: 0 0 40px rgba(246,192,84,0.25);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
/* Fallback: 100vh; Upgrade automat: 100svh unde e suportat */
.min-h-viewport {
    min-height: 100vh;
  }
@supports (height: 100svh) {
    .min-h-viewport {
      min-height: 100svh;
    }
  }
.\\[backface-visibility\\:hidden\\] {
  backface-visibility: hidden;
}
.\\[clip-path\\:inset\\(100\\%_0_0_0\\)\\] {
  clip-path: inset(100% 0 0 0);
}
.\\[filter\\:brightness\\(\\.95\\)_invert\\(1\\)_sepia\\(\\.25\\)_saturate\\(180\\%\\)_hue-rotate\\(330deg\\)_brightness\\(1\\.05\\)_contrast\\(\\.98\\)\\] {
  filter: brightness(.95) invert(1) sepia(.25) saturate(180%) hue-rotate(330deg) brightness(1.05) contrast(.98);
}
.\\[grid-template-rows\\:1fr_0fr\\] {
  grid-template-rows: 1fr 0fr;
}
.\\[padding-bottom\\:1px\\] {
  padding-bottom: 1px;
}
.\\[touch-action\\:pan-y\\] {
  touch-action: pan-y;
}
.\\[transform\\:translateZ\\(0\\)\\] {
  transform: translateZ(0);
}

:root {
  --backdrop: linear-gradient(
    180deg,
    rgba(106, 15, 82, 0.9) 0%,
    rgba(11, 29, 42, 0.95) 45%,
    rgba(11, 29, 42, 1) 100%
  );
}

.about-slider * {
  -webkit-tap-highlight-color: transparent;
}

html {
  scroll-behavior: smooth;
}
/* Fundal global sub tot conținutul */
html,
body {
  height: 100%;
}

body::before,
body::after {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none; /* să nu blocheze click-urile */
  z-index: -2; /* sub tot */
}

body::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
  background-attachment: fixed;
}

/* iOS Safari fix – dezactivează attachment:fixed și mută ușor focusul */
@supports (-webkit-touch-callout: none) {
  body::before {
    background-attachment: scroll !important;
    background-position: center 30% !important; /* ajustează 20–40% după gust */
  }
}

/* Fallback general pe ecrane mici */
@media (max-width: 768px) {
  body::before {
    background-attachment: scroll;
    background-position: center 30%;
  }
}

body::after {
  z-index: -1; /* peste poză, sub conținut */
  /* 3 straturi: vignetă radială + fade sus/jos + strat negru global */
  background: radial-gradient(
      140% 110% at 50% 40%,
      rgba(0, 0, 0, 0) 32%,
      rgba(0, 0, 0, 0.8) 62%,
      rgba(0, 0, 0, 0.95) 100%
    ),
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0) 28%,
      rgba(0, 0, 0, 0) 68%,
      rgba(0, 0, 0, 0.7) 100%
    ),
    rgba(0, 0, 0, 0.6);
  background-blend-mode: multiply, normal, normal;

  /* umbre inset puternice pe tot cadrul */
  box-shadow: inset 0 0 240px 140px rgba(0, 0, 0, 0.95),
    inset 0 0 60px 30px rgba(0, 0, 0, 0.95);
}

/* pe mobil – mai puțin agresiv */
@media (max-width: 768px) {
  body::after {
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 50%,
      rgba(0, 0, 0, 0.8) 82%,
      rgba(0, 0, 0, 0.95) 100%
    );
  }
}

:root {
  --scroll-blur: 0px; /* va fi setat din JS */
}

/* asigură-te că body::after rămâne semi-transparent (tu deja ai rgba<1) */
@supports (
  (backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))
) {
  body::after {
    backdrop-filter: blur(var(--scroll-blur));
    -webkit-backdrop-filter: blur(var(--scroll-blur));
  }
}

/* ===== Cube Animation (scoped) ===== */
@keyframes cube-hue {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

/* un wrapper ca să nu afectăm restul layout-ului */
.cube-stage {
  display: flex;
  justify-content: center;
  align-items: center;
  /* poți șterge min-height dacă îl pui într-o secțiune deja înaltă */
  min-height: 320px;
}

/* containerul cu animația */
.cube-container {
  position: relative;
  transform: skewY(-20deg);
  animation: cube-hue 5s linear infinite;
  /* ajustare fină de poziție, ca în exemplu */
  top: -20px;
}

/* un "cube" (stack) */
.cube-container .cube {
  position: relative;
  z-index: 2;
}

/* al doilea stack */
.cube-container .cube:nth-child(2) {
  z-index: 1;
  translate: -60px -60px; /* modern CSS */
}

/* al treilea stack */
.cube-container .cube:nth-child(3) {
  z-index: 3;
  translate: 60px 60px;
}

/* fiecare coloană dintr-un stack */
.cube-container .cube > div {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* poziționare pe grilă folosind variabilele --x/--y */
  translate: calc(-70px * var(--x)) calc(-60px * var(--y));
}

/* cubul propriu-zis */
.cube-container .cube > div > span {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 50px;
  background: #111;
  z-index: calc(1 * var(--i));
  transition: 1.5s;
}

/* muchia stângă */
.cube-container .cube > div > span::before {
  content: "";
  position: absolute;
  left: -40px;
  width: 40px;
  height: 100%;
  background: #0a0a0a;
  transform-origin: right;
  transform: skewY(45deg);
  transition: 1.5s;
}

/* muchia de sus */
.cube-container .cube > div > span::after {
  content: "";
  position: absolute;
  top: -40px;
  left: 0;
  width: 100%;
  height: 40px;
  background: #1a1a1a;
  transform-origin: bottom;
  transform: skewX(45deg);
  transition: 1.5s;
}

/* hover glow */
.cube-container .cube > div > span:hover {
  transition: 0s;
  background: #ef4149;
  filter: drop-shadow(0 0 30px #ef4149);
}
.cube-container .cube > div > span:hover::before,
.cube-container .cube > div > span:hover::after {
  transition: 0s;
  background: #ef4149;
}
.hover\\:z-50:hover {
  z-index: 50;
}
.hover\\:bg-black\\/40:hover {
  background-color: rgb(0 0 0 / 0.4);
}
.hover\\:bg-festival-glow:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 192 84 / var(--tw-bg-opacity));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-white\\/\\[0\\.08\\]:hover {
  background-color: rgb(255 255 255 / 0.08);
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.hover\\:text-festival-glow:hover {
  --tw-text-opacity: 1;
  color: rgb(246 192 84 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:shadow-glow:hover {
  --tw-shadow: 0 0 40px rgba(246,192,84,0.25);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-festival-glow\\/60:focus {
  --tw-ring-color: rgb(246 192 84 / 0.6);
}
.group:hover .group-hover\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:\\[clip-path\\:inset\\(0_0_0_0\\)\\] {
  clip-path: inset(0 0 0 0);
}
.group:hover .group-hover\\:\\[grid-template-rows\\:1fr_1fr\\] {
  grid-template-rows: 1fr 1fr;
}
@media (min-width: 640px) {

  .sm\\:bottom-4 {
    bottom: 1rem;
  }

  .sm\\:mt-4 {
    margin-top: 1rem;
  }

  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-20 {
    height: 5rem;
  }

  .sm\\:h-80 {
    height: 20rem;
  }

  .sm\\:h-\\[58vh\\] {
    height: 58vh;
  }

  .sm\\:max-h-\\[54vh\\] {
    max-height: 54vh;
  }

  .sm\\:min-h-\\[110px\\] {
    min-height: 110px;
  }

  .sm\\:w-\\[3\\.6rem\\] {
    width: 3.6rem;
  }

  .sm\\:max-w-\\[48ch\\] {
    max-width: 48ch;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:pb-80 {
    padding-bottom: 20rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-\\[16\\.5px\\] {
    font-size: 16.5px;
  }

  .sm\\:text-\\[17px\\] {
    font-size: 17px;
  }

  .sm\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:leading-tight {
    line-height: 1.25;
  }

  .sm\\:tracking-\\[0\\.35em\\] {
    letter-spacing: 0.35em;
  }
}
@media (min-width: 768px) {

  .md\\:pointer-events-none {
    pointer-events: none;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .md\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-12 {
    margin-top: 3rem;
  }

  .md\\:mt-2 {
    margin-top: 0.5rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline-block {
    display: inline-block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[420px\\] {
    height: 420px;
  }

  .md\\:h-\\[64vh\\] {
    height: 64vh;
  }

  .md\\:h-\\[90px\\] {
    height: 90px;
  }

  .md\\:max-h-\\[60vh\\] {
    max-height: 60vh;
  }

  .md\\:max-h-\\[82vh\\] {
    max-height: 82vh;
  }

  .md\\:min-h-\\[128px\\] {
    min-height: 128px;
  }

  .md\\:w-\\[4\\.2rem\\] {
    width: 4.2rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .md\\:p-12 {
    padding: 3rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:pb-\\[300px\\] {
    padding-bottom: 300px;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }

  .md\\:pt-20 {
    padding-top: 5rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:align-baseline {
    vertical-align: baseline;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:leading-tight {
    line-height: 1.25;
  }

  .md\\:will-change-transform {
    will-change: transform;
  }

  .group:hover .md\\:group-hover\\:scale-\\[1\\.04\\] {
    --tw-scale-x: 1.04;
    --tw-scale-y: 1.04;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
@media (min-width: 1024px) {

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[68vh\\] {
    height: 68vh;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
}
@media (min-width: 1325px) {

  .min-\\[1325px\\]\\:whitespace-nowrap {
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,yCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAoBjB;IACE,gDAAgD;EAClD;AAGE;EAAA,oBAA6H;EAA7H,mBAA6H;EAA7H,qBAA6H;EAA7H,kBAA6H;EAA7H,wDAA6H;EAA7H,oBAA6H;EAA7H,qBAA6H;EAA7H,oBAA6H;EAA7H,uBAA6H;EAA7H,gBAA6H;EAA7H,oBAA6H;EAA7H,0CAA6H;EAA7H,wJAA6H;EAA7H,wDAA6H;EAA7H;AAA6H;AAA7H;EAAA,2CAA6H;EAA7H,oDAA6H;EAA7H;AAA6H;AAG/H,6DAA6D;AAC7D;IACE,iBAAiB;EACnB;AACA;IACE;MACE,kBAAkB;IACpB;EACF;AApCF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE;;;;;GAKC;AACH;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;AA4DA,qCAAqC;AACrC;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,oBAAoB,EAAE,+BAA+B;EACrD,WAAW,EAAE,YAAY;AAC3B;;AAEA;EACE,4EAA+D;EAC/D,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE;IACE,wCAAwC;IACxC,0CAA0C,EAAE,+BAA+B;EAC7E;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;AACF;;AAEA;EACE,WAAW,EAAE,6BAA6B;EAC1C,oEAAoE;EACpE;;;;;;;;;;;;;sBAaoB;EACpB,+CAA+C;;EAE/C,wCAAwC;EACxC;2CACyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE;IACE;;;;;KAKC;EACH;AACF;;AAEA;EACE,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA,0EAA0E;AAC1E;;;EAGE;IACE,yCAAyC;IACzC,iDAAiD;EACnD;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mEAAmE;EACnE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,4CAA4C;EAC5C,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,sBAAsB,EAAE,eAAe;AACzC;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sDAAsD;EACtD,wDAAwD;AAC1D;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,mBAAmB;EACnB,qCAAqC;AACvC;AACA;;EAEE,cAAc;EACd,mBAAmB;AACrB;AA7QA;EAAA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;EAAA,kBA8QA;EA9QA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;EAAA,oBA8QA;EA9QA;AA8QA;AA9QA;EAAA,oBA8QA;EA9QA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;EAAA,2CA8QA;EA9QA,oDA8QA;EA9QA;AA8QA;AA9QA;EAAA,8BA8QA;EA9QA;AA8QA;AA9QA;EAAA,2GA8QA;EA9QA,yGA8QA;EA9QA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;EAAA,qBA8QA;EA9QA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;EAAA;AA8QA;AA9QA;;EAAA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,uBA8QA;IA9QA,4DA8QA;IA9QA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,oBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,qBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,oBA8QA;IA9QA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,kBA8QA;IA9QA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,mBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,mBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,kBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,kBA8QA;IA9QA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;AAAA;AA9QA;;EAAA;IAAA;EA8QA;;EA9QA;IAAA,gBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,oBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,mBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,iBA8QA;IA9QA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,iBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,kBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,qBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,iBA8QA;IA9QA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,mBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,eA8QA;IA9QA;EA8QA;;EA9QA;IAAA,kBA8QA;IA9QA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,mBA8QA;IA9QA;EA8QA;;EA9QA;IAAA,kBA8QA;IA9QA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,kBA8QA;IA9QA,kBA8QA;IA9QA;EA8QA;AAAA;AA9QA;;EAAA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA;EA8QA;;EA9QA;IAAA,kBA8QA;IA9QA;EA8QA;AAAA;AA9QA;;EAAA;IAAA;EA8QA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --backdrop: linear-gradient(\n    180deg,\n    rgba(106, 15, 82, 0.9) 0%,\n    rgba(11, 29, 42, 0.95) 45%,\n    rgba(11, 29, 42, 1) 100%\n  );\n}\n\n.about-slider * {\n  -webkit-tap-highlight-color: transparent;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n@layer utilities {\n  .text-glow {\n    text-shadow: 0 2px 22px rgba(246, 192, 84, 0.35);\n  }\n\n  .btn-primary {\n    @apply inline-flex items-center px-6 py-3 rounded-full bg-festival-glow text-black font-semibold hover:shadow-glow transition;\n  }\n\n  /* Fallback: 100vh; Upgrade automat: 100svh unde e suportat */\n  .min-h-viewport {\n    min-height: 100vh;\n  }\n  @supports (height: 100svh) {\n    .min-h-viewport {\n      min-height: 100svh;\n    }\n  }\n\n  .dot-left::before {\n    content: \"\";\n    position: absolute;\n    top: 15%;\n    transform: translateY(-50%);\n    right: -37px;\n    width: 10px;\n    height: 10px;\n    border-radius: 9999px;\n    background: theme(\"colors.festival.glow\"); /* <— ghilimele! */\n    box-shadow: 0 0 0 6px rgb(255 255 255 / 0.08);\n  }\n\n  .backface-hidden {\n    backface-visibility: hidden;\n    transform: translateZ(0);\n  }\n\n  .dot-right::before {\n    content: \"\";\n    position: absolute;\n    top: 15%;\n    transform: translateY(-50%);\n    left: -37px;\n    width: 10px;\n    height: 10px;\n    border-radius: 9999px;\n    background: theme(\"colors.festival.glow\"); /* <— ghilimele! */\n    box-shadow: 0 0 0 6px rgb(255 255 255 / 0.08);\n  }\n  .full-bleed {\n    width: 100vw;\n    position: relative;\n    left: 50%;\n    right: 50%;\n    margin-left: -50vw;\n    margin-right: -50vw;\n  }\n}\n/* Fundal global sub tot conținutul */\nhtml,\nbody {\n  height: 100%;\n}\n\nbody::before,\nbody::after {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  pointer-events: none; /* să nu blocheze click-urile */\n  z-index: -2; /* sub tot */\n}\n\nbody::before {\n  background: url(\"./assets/poster.jpg\") center / cover no-repeat;\n  background-attachment: fixed;\n}\n\n/* iOS Safari fix – dezactivează attachment:fixed și mută ușor focusul */\n@supports (-webkit-touch-callout: none) {\n  body::before {\n    background-attachment: scroll !important;\n    background-position: center 30% !important; /* ajustează 20–40% după gust */\n  }\n}\n\n/* Fallback general pe ecrane mici */\n@media (max-width: 768px) {\n  body::before {\n    background-attachment: scroll;\n    background-position: center 30%;\n  }\n}\n\nbody::after {\n  z-index: -1; /* peste poză, sub conținut */\n  /* 3 straturi: vignetă radială + fade sus/jos + strat negru global */\n  background: radial-gradient(\n      140% 110% at 50% 40%,\n      rgba(0, 0, 0, 0) 32%,\n      rgba(0, 0, 0, 0.8) 62%,\n      rgba(0, 0, 0, 0.95) 100%\n    ),\n    linear-gradient(\n      180deg,\n      rgba(0, 0, 0, 0.6) 0%,\n      rgba(0, 0, 0, 0) 28%,\n      rgba(0, 0, 0, 0) 68%,\n      rgba(0, 0, 0, 0.7) 100%\n    ),\n    rgba(0, 0, 0, 0.6);\n  background-blend-mode: multiply, normal, normal;\n\n  /* umbre inset puternice pe tot cadrul */\n  box-shadow: inset 0 0 240px 140px rgba(0, 0, 0, 0.95),\n    inset 0 0 60px 30px rgba(0, 0, 0, 0.95);\n}\n\n/* pe mobil – mai puțin agresiv */\n@media (max-width: 768px) {\n  body::after {\n    background: linear-gradient(\n      180deg,\n      rgba(0, 0, 0, 0) 50%,\n      rgba(0, 0, 0, 0.8) 82%,\n      rgba(0, 0, 0, 0.95) 100%\n    );\n  }\n}\n\n:root {\n  --scroll-blur: 0px; /* va fi setat din JS */\n}\n\n/* asigură-te că body::after rămâne semi-transparent (tu deja ai rgba<1) */\n@supports (\n  (backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))\n) {\n  body::after {\n    backdrop-filter: blur(var(--scroll-blur));\n    -webkit-backdrop-filter: blur(var(--scroll-blur));\n  }\n}\n\n/* ===== Cube Animation (scoped) ===== */\n@keyframes cube-hue {\n  0% {\n    filter: hue-rotate(0deg);\n  }\n  100% {\n    filter: hue-rotate(360deg);\n  }\n}\n\n/* un wrapper ca să nu afectăm restul layout-ului */\n.cube-stage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* poți șterge min-height dacă îl pui într-o secțiune deja înaltă */\n  min-height: 320px;\n}\n\n/* containerul cu animația */\n.cube-container {\n  position: relative;\n  transform: skewY(-20deg);\n  animation: cube-hue 5s linear infinite;\n  /* ajustare fină de poziție, ca în exemplu */\n  top: -20px;\n}\n\n/* un \"cube\" (stack) */\n.cube-container .cube {\n  position: relative;\n  z-index: 2;\n}\n\n/* al doilea stack */\n.cube-container .cube:nth-child(2) {\n  z-index: 1;\n  translate: -60px -60px; /* modern CSS */\n}\n\n/* al treilea stack */\n.cube-container .cube:nth-child(3) {\n  z-index: 3;\n  translate: 60px 60px;\n}\n\n/* fiecare coloană dintr-un stack */\n.cube-container .cube > div {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  /* poziționare pe grilă folosind variabilele --x/--y */\n  translate: calc(-70px * var(--x)) calc(-60px * var(--y));\n}\n\n/* cubul propriu-zis */\n.cube-container .cube > div > span {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  background: #111;\n  z-index: calc(1 * var(--i));\n  transition: 1.5s;\n}\n\n/* muchia stângă */\n.cube-container .cube > div > span::before {\n  content: \"\";\n  position: absolute;\n  left: -40px;\n  width: 40px;\n  height: 100%;\n  background: #0a0a0a;\n  transform-origin: right;\n  transform: skewY(45deg);\n  transition: 1.5s;\n}\n\n/* muchia de sus */\n.cube-container .cube > div > span::after {\n  content: \"\";\n  position: absolute;\n  top: -40px;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: #1a1a1a;\n  transform-origin: bottom;\n  transform: skewX(45deg);\n  transition: 1.5s;\n}\n\n/* hover glow */\n.cube-container .cube > div > span:hover {\n  transition: 0s;\n  background: #ef4149;\n  filter: drop-shadow(0 0 30px #ef4149);\n}\n.cube-container .cube > div > span:hover::before,\n.cube-container .cube > div > span:hover::after {\n  transition: 0s;\n  background: #ef4149;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
